import { msg } from '@lingui/macro'

import { CartModal } from '@segments/Cart'
import * as React from 'react'

import { useProductDetailControlCtx } from '~shared/segments/ProductDetail'

const emptyCartMessage = msg`cart is empty, for now...`
const cartTitle = msg`Your Cart`

type TProps = NoChildren & Pick<PropsOf<typeof CartModal>, 'isOpen' | 'onClose' | 'isFullScreen'>

/**
 * Editable CartModal as rendered on tablet/mobile MenuScreen.
 */
export const MenuModalCart: React.FC<TProps> = ({ isOpen, onClose, isFullScreen }) => {
  const { openCartItemDetail } = useProductDetailControlCtx()

  return (
    <CartModal
      isOpen={isOpen}
      onClose={onClose}
      cartTitle={cartTitle}
      isFullScreen={isFullScreen}
      emptyCartMessage={emptyCartMessage}
      onCartItemEdit={(item) => {
        openCartItemDetail({
          product: item.firstItem.product,
          cartItemIds: item.items.map((item) => item.id),
        })
      }}
    />
  )
}
